import videojs from 'video.js';

const VideoJsButton = videojs.getComponent('Button');

class VideoThumbnailButton extends VideoJsButton {
  constructor(player, options) {
    super(player, options);

    this.controlText('Set as thumbnail');
    this.addClass('vjs-thumbnail-button');

    // Hide button by default, will be shown for owners
    this.hide();

    // Set up initial state
    this.isCapturing = false;
    this.isOwner = options.isOwner || false;

    // Show button only for owners
    if (this.isOwner) {
      this.show();
    }
  }

  buildCSSClass() {
    return 'vjs-thumbnail-button vjs-control vjs-button';
  }

  createEl() {
    const el = super.createEl(
      'button',
      {
        className: this.buildCSSClass(),
        'aria-live': 'polite',
        title: 'Set as thumbnail',
      },
      {
        type: 'button',
      }
    );

    // Add camera icon
    const iconEl = videojs.dom.createEl(
      'span',
      {
        className: 'vjs-icon-placeholder vjs-thumbnail-icon',
      },
      {
        'aria-hidden': 'true',
      }
    );

    el.appendChild(iconEl);
    return el;
  }

  handleClick() {
    if (this.isCapturing) {
      return; // Prevent multiple clicks during capture
    }

    const currentTime = Math.round(this.player().currentTime());

    // Set loading state
    this.setCapturing(true);

    // Trigger custom event with timestamp
    this.player().trigger('thumbnailCapture', { timestamp: currentTime });
  }

  setCapturing(capturing) {
    this.isCapturing = capturing;

    if (capturing) {
      this.addClass('vjs-thumbnail-capturing');
      this.controlText('Capturing thumbnail...');
    } else {
      this.removeClass('vjs-thumbnail-capturing');
      this.controlText('Set as thumbnail');
    }
  }

  setOwnerStatus(isOwner) {
    this.isOwner = isOwner;

    if (isOwner) {
      this.show();
    } else {
      this.hide();
    }
  }
}

// Register the component with Video.js
videojs.registerComponent('ThumbnailCaptureButton', VideoThumbnailButton);

export default VideoThumbnailButton;
